import '../chat/chat.css';
import React, { useState, useEffect, useRef } from 'react';
import send from'../../images/send.png'
import chatBG from'../../images/chatBG.png'
import {IsLSWork} from '../app/app'
import { audio, ambient, musicContinue, musicContinueSwitch, playMusic, pauseMusic, setVolume, transitionVolume, stopMusic, isPlaying, playEffects, setVolumeEffects, stopEffects, transitionVolumeEffects, isPlayingEffects, playAmbient, setVolumeAmbient, transitionVolumeAmbient, stopAmbient} from '../musicEngine/musicEngine';
import notificationSound from'../../m/notification.js'
import messageSound from'../../m/message.js'
import messageSent from'../../m/messageSent.js'
import whoosh from'../../m/whoosh.js'

function GroupChat({mess, from, state, step, goNext, goMenu, setFailedGame, gallery, setGallery, mainPisi, pChoise, gallerySC, goNextOnI, language, hzAdjuster}) {
  const [isLS, setIsLS] = useState(IsLSWork());
  const [save, setSave] = useState(0);
  const [messages, setMessage] = useState([]);
  const [answers, setAnswers] = useState();
  const [margin, setMargin] = useState();
  const [myAnswers, setMyAnswers] = useState([]);
  const [opacity, setOpacity] = useState("none");
  const [white, setWhite] = useState(1);
  const [typing, setTyping] = useState(false);
  const [opType, setOpType] = useState(0);
  const [options, setOptions] = useState([]);
  const [messNum, setMessNum] = useState(0);
  const [next, setNext] = useState();
  const [nextOnI, setNextOnI] = useState();
    const [index, setIndex] = useState(20);
    const [moveTo, setMoveTo] = useState();
  const inputRef = useRef(null);
   const notification = useRef();
   const notificationImg = useRef();
   let answersAppeared = useRef(false);
   let savedAnswers = useRef(new Array());
   let chatCompleted = useRef(false);
   let answered;
   const answer0 = useRef(null);
   const answer1 = useRef(null);

   let textTranslation = {
     en:{
       members:" members",
       typing:" is typing",
       photo:" is sending a photo",
       video:" is sending a video"
     },
     ru:{
       members:" участников",
       typing:" печатает",
       photo:" загружает изабражение",
       video:" загружает видео"
     }
   }

  useEffect(() => {
    document.addEventListener('deviceready', deviceReadyFunc, false);
    function deviceReadyFunc() {
      document.addEventListener('backbutton', onBackButton, false);
    }
    function onBackButton(e) {
      e.preventDefault();
      goToMenu();
    }
    return () => {
      document.removeEventListener('deviceready', deviceReadyFunc, false);
      document.removeEventListener('backbutton', onBackButton, false);
    }
  },[]);

  useEffect(() => {
    if(state.current[step] == undefined){
      state.current.splice(step, 1, {groupChat:true, completed:chatCompleted.current, savedAnswers:JSON.stringify([])})
      if(isLS){
      localStorage.setItem('stateSC2', JSON.stringify(state.current));
    }
    }
    if(state.current[step]["completed"]){
      chatCompleted.current = state.current[step]["completed"];
    }else{
      chatCompleted.current = false;
    }
    if(state.current[step]["savedAnswers"]){
       savedAnswers.current = JSON.parse(state.current[step]["savedAnswers"]);
    }else{
      savedAnswers.current = [];
    }
    setMargin(0-notification.current.clientHeight);
    start(messNum);
    changeWhite(true);
},[]);

useEffect(() => {
  if(inputRef.current != null){
  inputRef.current.addEventListener('keydown', function(e) {
  if(e.keyCode === 13) {
  check();
  }
  });
}
},[inputRef.current]);


useEffect(() => {
  var d = document.getElementById('messages');
if(d.scrollHeight > d.clientHeight) {
d.scrollTop = d.scrollHeight - d.clientHeight;
}
});

useEffect(() => {
    state.current.splice(step, 1, {groupChat:true, completed:chatCompleted.current, savedAnswers:JSON.stringify(savedAnswers.current)})
    if(isLS){
    localStorage.setItem('stateSC2', JSON.stringify(state.current));
  }
},[save]);

async function go(){
  chatCompleted.current = true;
  setSave(previous => previous + 1)
  setIndex(20);
  playEffects(whoosh, false);
  await changeWhite();
  goNext();
}

async function goOnI(){
  setIndex(20);
  playEffects(whoosh, false);
  await changeWhite();
  if(moveTo === undefined){
    goNextOnI(3);
  }else{
    goNextOnI(moveTo);
  }
}

async function goToMenu(){
  setIndex(20);
  playEffects(whoosh, false);
  await changeWhite();
  goMenu();
}
function changeOnOff(toLow, setter){
  return new Promise((resolve, reject) => {
  if(toLow){
    var op=1;
    change(toLow);
  }else{
    var op=0;
    change();
  }
  function change(toLow){
  if(toLow){
    if(op>0){
      op-=0.03;
    setter(op);
    setTimeout(ChangetoLow, 10);
  }else{
    resolve();
    setIndex(14);
    return;
  }
}else{
  if(op<1){
    op+=0.03;
  setter(op);
  setTimeout(change, 10);
}else{
  resolve();
  return;
}
}

function ChangetoLow(){
   change(true);
}
}
});
}
function changeWhite(toLow){
  return new Promise((resolve, reject) => {
  if(toLow){
    var op=1;
    change(toLow);
  }else{
    var op=0;
    change();
  }
  function change(toLow){
  if(toLow){
    if(op>0){
      op-=0.03;
    setWhite(op);
    setTimeout(ChangetoLow, 10);
  }else{
    resolve();
    setIndex(14);
    return;
  }
}else{
  if(op<1){
    op+=0.03;
  setWhite(op);
  setTimeout(change, 10);
}else{
  resolve();
  return;
}
}

function ChangetoLow(){
   change(true);
}
}
});
}



async function myAnswer(e){
  if(answersAppeared.current){
    await ans();
  }else{return}


  function ans(){
        return new Promise(async (resolve, reject) => {
            setIndex(18);
            //changeOpacity(true);
            let input = e.target.outerHTML;
            let name = input.split('name="')[1];
            name = name.split('"')[0];
            setVolumeEffects(0.05);
            playEffects(messageSent, false);
            await changeSetting(eval("answer"+name),"current.style.transform", document.body.clientWidth*-0.1, "translateX", 3);
            await changeSetting(eval("answer"+name),"current.style.transform", document.body.clientWidth, "translateX", 20);
            if(name == 0){
              name=1;
            }else{
              name=0;
            }
            await changeSetting(eval("answer"+name),"current.style.transform", document.body.clientWidth*0.1, "translateX", 6);
            await changeSetting(eval("answer"+name),"current.style.transform", -document.body.clientWidth, "translateX", 25);
            setOpacity("none");
            answersAppeared.current = false;
            if(input.includes('value="') === true){
              let preAns = input.split('value="')[1];
              preAns = preAns.split('"')[0];
              setMessage([...messages, {text:preAns, from: 'messageFromMe'}]);
              answered=preAns;
            }

            start(messNum);
            resolve();
          });
        }
}

function waitin(){
  return new Promise((resolve, reject) => {
    document.getElementById("wrap").onclick=ff;
function ff(){
  resolve();
}
  });
}

function notif(up){
return new Promise((resolve, reject) => {
 let marginTopDown = window.innerHeight*0.03;
 let marginTopUp = 0-notification.current.clientHeight;
  let minus = 4;
  if(up){
    var mar=2;
    change(up);
  }else{
    var mar=0-notification.current.clientHeight;
    change();
  }
  function change(up){
  if(up){
    if(mar>marginTopUp){
      mar-=4;
    setMargin(mar);
    setTimeout(ChangetoLow, 5);
  }else{
    resolve();
    return;
  }
}else{
  if(mar<marginTopDown){
    if(mar<(marginTopDown-notification.current.clientHeight)/2){
      mar+=minus;
    }else{
      let min = (4-1)/(((marginTopDown+notification.current.clientHeight)/2)/minus);
      minus-=min;
      if(minus<0){
        minus=2;
      }
        mar+=minus;
    }
  setMargin(mar);
  setTimeout(change, 5);
}else{
  resolve();
  return;
}
}

function ChangetoLow(){
   change(true);
}
}
});
}

async function check(){
  var crypto = require('crypto');
  const sha256 = x => crypto.createHash('sha256').update(x.toLowerCase(), 'utf8').digest('hex');
  setMessage((prev) => [...prev,{text:inputRef.current.value, from:'messageFromMe'},]);
  if(inputRef.current.value.length < 7){
if(sha256(inputRef.current.value) === "837dbfe793d67b893ca200e13b719b0943dcce6076172c43b34eba45992ebbfd"){
  setMessNum(8);
  start(8);
if(isLS){
  localStorage.setItem('failedGameSC2', 0);
}
  setFailedGame(0);
  await changeOnOff(true,setOpType);
  setTyping(false);
}else{
  await changeOnOff(true,setOpType);
  setTyping(false);
  //await typAnim(2 , {text:"Nope",from:'messageFromThem', name:"Gideon", avatar:gideon}, {text:"",from:'messageFromMe'});
  //await typAnim(1 , {text:"You got other options",from:'messageFromThem', name:"Gideon", avatar:gideon}, {text:"Неа",from:'messageFromThem', name:"Gideon", avatar:gideon});

  setMessNum(33);
  start(33);
}
}else{
  await changeOnOff(true,setOpType);
  setTyping(false);
  //await typAnim(2 , {text:"Nope",from:'messageFromThem', name:"Gideon", avatar:gideon}, {text:"",from:'messageFromMe'});
  //await typAnim(1 , {text:"You got other options",from:'messageFromThem', name:"Gideon", avatar:gideon}, {text:"Неа",from:'messageFromThem', name:"Gideon", avatar:gideon});

  setMessNum(33);
  start(33);
}
}

async function start(startingFrom){
  for(let i=startingFrom;i<mess.length;i++){
    if(mess[i].answered){
      if(answered !== mess[i].answered){
        if(mess[i].endofAnswer){
          answered=undefined;
        }
        continue;
      }
      if(mess[i].endofAnswer){
        answered=undefined;
      }
    }
    if(mess[i].asking){
      setTyping(true);
      changeOnOff(false,setOpType);
      break;
    }
    if(mess[i].choose){
      mess[i].img = mess[i].choose[pChoise];
    }
    if(mess[i]["gallery"] !== undefined && gallerySC.current[mess[i]["gallery"][2]][1] == "0"){
        gallerySC.current[mess[i]["gallery"][2]][1] = "1";
        if(isLS){
        localStorage.setItem('gallerySC2', JSON.stringify(gallerySC.current));
      }
    }
    if(mess[i].pollChange){
      if(mess[i].playersChoise){
        await playerChoise(mess[i].pollChange);
      }else{
      await changePoll(mess[i].pollChange);
      await waitin();
      continue;
    }
    }
    let delay;
    if(mess[i].img || mess[i].poll){
      delay = 3;
    }else if(mess[i].notification){
      delay = 0;
    }else{
      delay = Math.floor(mess[i].text.length / 40);
      if(delay===0) delay=1;
    }
    if(mess[i].notification){
      notificationImg.current.src = mess[i].avatar;
      document.getElementsByClassName("nameNot")[0].innerHTML = mess[i].name;
      document.getElementsByClassName("messNot")[0].innerHTML = mess[i].notification;
      setVolumeEffects(0.3);
      playEffects(notificationSound, false);
      await notif();
    }
    if(mess[i].vibration){
      try{
        navigator.vibrate(mess[i].vibration);
    }catch(e){
      console.log(e);
    }
    }
    if(mess[i].text || mess[i].img){
if(mess[i-1] && mess[i-1].answers){
  await typAnim(delay, mess[i], mess[i-1], true);
}else{
  await typAnim(delay, mess[i], mess[i-1], false);
}
delay=0;
}
setMessNum(i+1);
await waitin();
if(mess[i].notification){
  await notif(true);
}
if(mess[i].answers){
  break;
}
if(mess[i].playersChoise){
  break;
}
if(mess[i].endOfChat){
  go();
  break;
}
if(mess[i].skipAnswers){
  answered=undefined;
}
  }
}

async function changePoll(data){
  return new Promise((resolve, reject) => {
  let dataAll = 0;
  data.map((item) => dataAll += item);
  let dataPer = [];
  let maxTime=0;
  for(let i=0;i<data.length;i++){
    dataPer.push(parseInt(data[i]/dataAll*100));
    changeWidth(document.getElementsByClassName("percents"+i)[0], dataPer[i]);
    if(Math.abs(parseInt(document.getElementsByClassName("percents"+i)[0].style.width)-dataPer[i])*24>maxTime){
      maxTime=Math.abs(parseInt(document.getElementsByClassName("percents"+i)[0].style.width)-dataPer[i])*24;
    }
    document.getElementsByClassName("perc"+i)[0].innerHTML = dataPer[i] +"%";
  }
  maxTime+=50;
  setTimeout(res,maxTime);
  function res(){
    resolve();
  }
});
}

async function playerChoise(data){
setIndex(0);
setOptions([...data]);
}
async function chooseOption(e){
  let arr = [...options];
  arr[e.target.id]+=1;
  document.getElementsByClassName("optionText"+e.target.id)[0].style.fontWeight = 500;
  document.getElementsByClassName("percents"+e.target.id)[0].style.background = "#5600CA";
  await changePoll(arr);
  if(e.target.id === "0"){
    setMessNum(38);
    start(38);
  }else if(e.target.id === "1"){
    setMessNum(74);
    start(74);
  }else if(e.target.id === "2"){
    setMessNum(74);
    start(74);
  }else if(e.target.id === "3"){
    setMessNum(54);
    start(54);
  }
  setIndex(14);
}
function changeWidth(change, finish){
  let start = parseInt(change.style.width);
  if(start < finish){
    change.style.width = (start+1)+"%";
    setTimeout(changeAnotherTime, 20);
  }else if(start > finish){
    change.style.width = (start-1)+"%";
    setTimeout(changeAnotherTime, 20);
  }else if(start === finish){
    return;
  }
  function changeAnotherTime(){
    changeWidth(change, finish);
  }
}

function changeOpacity(toLow){
  if(toLow){
    var op=1;
    change(toLow);
  }else{
    var op=0;
    change();
  }
  function change(toLow){
  if(toLow){
    if(op>0){
      op-=0.1;
    setOpacity(op);
    setTimeout(ChangetoLow, 20);
  }else{
    setAnswers(undefined);
    return;
  }
}else{
  if(op<1){
    op+=0.1;
  setOpacity(op);
  setTimeout(change, 20);
}else{
  return;
}
}

function ChangetoLow(){
   change(true);
}
}
}
  function typAnim(end,message, prevMessage, afterAnswers){
    return new Promise((resolve, reject) => {
    let i=0,j=0;
    if(message.from === 'messageFromMe'){
      j=end;
    }else{
      document.getElementById("wrap").onclick=endAnim;
      function endAnim(){
          j=end;
        }
    }
    anim();
    async function anim(){
      try{
      if(j===end){
        if(!message.audio && !afterAnswers){
          setVolumeEffects(0.1);
          playEffects(messageSound, false);
        }
        if(message.from ==="messageFromThem"){
            if(prevMessage){
          if(message.avatar === prevMessage.avatar){
            let cloneMessage = {};
            for (let key in message) {
              cloneMessage[key] = message[key];
            }
            setMessage((prev) => {
              let cloneOfPrevObj = {};
              let clonePrev = [...prev]
              for (let key in prev[prev.length-1]) {
                cloneOfPrevObj[key] = prev[prev.length-1][key];
              }
              clonePrev.pop();
  cloneOfPrevObj.avatar = false;
  cloneMessage.name = false;
  return [...clonePrev, cloneOfPrevObj, cloneMessage];});
}else{
  setMessage((prev) => [...prev, message]);
}
      }else{
          setMessage((prev) => [...prev, message]);
        }

      }else{
        setMessage((prev) => [...prev, message]);
      }

      if(message.answers){
        setIndex(14);

        document.getElementById('typ').innerHTML = from.members+textTranslation[language]["members"];
        setAnswers(message.answers);
        await waitin();
        answer0.current.style.transform = "translateX("+document.body.clientWidth+"px)";
        answer1.current.style.transform = "translateX("+(-1*document.body.clientWidth)+"px)";
        setOpacity("flex");
        await changeSetting(answer0,"current.style.transform", 0, "translateX", 14);
        await changeSetting(answer0,"current.style.transform", document.body.clientWidth*-0.12, "translateX", 3);
        changeSetting(answer0,"current.style.transform", 0, "translateX", 3);
        await changeSetting(answer1,"current.style.transform", 0, "translateX", 12);
        await changeSetting(answer1,"current.style.transform", document.body.clientWidth*0.12, "translateX", 3);
        await changeSetting(answer1,"current.style.transform", 0, "translateX", 2);
        answersAppeared.current = true;
      }
      /*if(message.endOfChat){
        if(message.endOfChat.skip){
          if(message.endOfChat.move){
            setMoveTo(message.endOfChat.move);
          }
          setTimeout(setNextOnIWithDelay, 2000)
        }else{
        setTimeout(setNextWithDelay, 2000)
        }
      }
      function setNextOnIWithDelay(){
        setIndex(14);
        setNextOnI({text: message.endOfChat.text});
      }
      function setNextWithDelay(){
        setIndex(14);
        setNext({text: message.endOfChat.text});
      }*/
      document.getElementById('typ').innerHTML = from.members+textTranslation[language]["members"];
          resolve()
          return;

        }
      if(i===0){
        if(message.img && message.video){
          document.getElementById('typ').innerHTML = message.name + textTranslation[language]["video"] + "...";
        }else if(message.img){
          document.getElementById('typ').innerHTML = message.name + textTranslation[language]["photo"] + "...";
        }else{
          document.getElementById('typ').innerHTML = message.name + textTranslation[language]["typing"] + "...";
        }
  i++;
    setTimeout(anim,200);
  return;
}
if(i===1){
  if(message.img && message.video){
    document.getElementById('typ').innerHTML = message.name + textTranslation[language]["video"] + ".";
  }else if(message.img){
    document.getElementById('typ').innerHTML = message.name + textTranslation[language]["photo"] + ".";
  }else{
    document.getElementById('typ').innerHTML = message.name + textTranslation[language]["typing"] + ".";
  }
i++;
  setTimeout(anim,200);
    return;
}
if(i===2){
  if(message.img && message.video){
    document.getElementById('typ').innerHTML = message.name + textTranslation[language]["video"] + "..";
  }else if(message.img){
    document.getElementById('typ').innerHTML = message.name + textTranslation[language]["photo"] + "..";
  }else{
    document.getElementById('typ').innerHTML = message.name + textTranslation[language]["typing"] + "..";
  }
  j++;
  i=0;
    setTimeout(anim,200);
  return;
}
}catch(e){
  console.log(e);
}
}
});
  }

  function changeSetting(obj, setting, changeTo, um, speed, char, float, stopLoading){
    speed=speed*2.3*hzAdjuster;
    return new Promise((resolve, reject) => {
      const props = setting
          .split(/[./[\]]/g)
          .filter(p => p);
      const prop = props.pop();
      const parent = props.reduce((result, key) => result[key], obj);
      var i;
      if(setting == "current.style.transform" || setting == "style.transform"){
        if(float){
          i = parseFloat(parent[prop].split("(")[1].split(")")[0]);
        }else{
          i = Math.round(parseFloat(parent[prop].split("(")[1].split(")")[0]));
        }
      }else if(setting == "current.style.transform" || setting == "style.transform" && um == "translateX"){
        if(float){
          i = parseFloat(parent[prop].split("(")[1].split("px)")[0]);
        }else{
          i = Math.round(parseFloat(parent[prop].split("(")[1].split("px)")[0]));
        }
      }else if(setting == "current.style.filter" || setting == "style.filter"){
        if(float){
          i = parseFloat(parent[prop].split("(")[1].split("px)")[0]);
        }else{
          i = Math.round(parseFloat(parent[prop].split("(")[1].split("px)")[0]));
        }
      }else{
        if(float){
        i = parseFloat(parent[prop]);
        }else{
        i = Math.round(parseFloat(parent[prop]));
        }
      }
      let slowDownTrigger = 0;
      let slower = 8;
      change();
    function change(){
      if(i>changeTo){
        i-=speed;
        if(i<=changeTo){
          i = changeTo;
          if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
            parent[prop] = "scale("+i+")";
          }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
            parent[prop] = "rotateY("+i+"deg)";
          }else if((setting == "current.style.transform" || setting == "style.transform") && um == "translateX"){
            parent[prop] = "translateX("+i+"px)";
          }else if((setting == "current.style.filter" || setting == "style.filter")){
            parent[prop] = "blur("+i+"px)";
          }else{
            parent[prop] = i+um;
          }
          resolve();
          return;
        }
    }else if(i<changeTo){
      i+=speed;
      if(i>=changeTo){
        i = changeTo;
        if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
          parent[prop] = "scale("+i+")";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
          parent[prop] = "rotateY("+i+"deg)";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "translateX"){
          parent[prop] = "translateX("+i+"px)";
        }else if((setting == "current.style.filter" || setting == "style.filter")){
          parent[prop] = "blur("+i+"px)";
        }else{
          parent[prop] = i+um;
        }
        resolve();
        return;
      }
    }else{
      if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
        parent[prop] = "scale("+i+")";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
        parent[prop] = "rotateY("+i+"deg)";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "translateX"){
        parent[prop] = "translateX("+i+"px)";
      }else if((setting == "current.style.filter" || setting == "style.filter")){
        parent[prop] = "blur("+i+"px)";
      }else{
        parent[prop] = i+um;
      }
      resolve();
      return;
    }
    if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
      parent[prop] = "scale("+i+")";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
      parent[prop] = "rotateY("+i+"deg)";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "translateX"){
      parent[prop] = "translateX("+i+"px)";
    }else if((setting == "current.style.filter" || setting == "style.filter")){
      parent[prop] = "blur("+i+"px)";
    }else{
      parent[prop] = i+um;
    }
  requestAnimationFrame(change);
  return;
  }
  });
  }

  return (
<div className='wrap'>
{next && <div className='nextDay' onClick={go}><p>{next.text}</p></div>}
{nextOnI && <div className='nextDay' onClick={goOnI}><p>{nextOnI.text}</p></div>}
{typing && <div className='type' style={{opacity:opType}}><input type='text' placeholder='Message' ref={inputRef}/><img src={send} onClick={check}/> </div>}
<div className='clickWrap' id='wrap' style={{opacity:white,zIndex:index}}></div>
{ answers &&
<div className='answers' style={{display:opacity}}>
{answers.map((item,index)=>{
  return (
    <div className='answer' ref={eval("answer"+index)} style={{transform: "translateX(0px)"}} name={index} key={index}><div className="answerCover" onClick={myAnswer} value={item} name={index}></div>{item.img? <img src={item.img} height="100px"/> : <input type="text" onClick={myAnswer} disabled={true} readOnly id="icon" value={item}/>}</div>
  )
})}
</div>
}

<div className="notification" id="notification" ref={notification} style={{top:margin+"px"}}>
<div className='pict3'>
  <img className='img' src="" ref={notificationImg} alt="" />
</div>
<h6 className="nameNot"></h6>
<p className="messNot"></p>
</div>


<div className='bgPic' style={{backgroundImage:"url("+chatBG+")"}}></div>
<div className='topLine'>
<div className="arrow1" onClick={goToMenu}>
    <div></div>
</div>
<div className='pict'>
  <img className='img' src={from.photo} alt="" />
</div>
<div>
<p className='nameofchat'>{from.name}</p>
<p className='typ' id="typ">{from.members+textTranslation[language]["members"]}</p>
</div>

</div>
<div id='back'></div>
<div className='messages' id='messages'>
{messages.map(function (item, index) {
return(
  <div className={"container"+item.from} key={index}>
  {item.avatar && <div className='avatar'>
    <img className='img' src={item.avatar} alt="" />
  </div>}
  <div className={item.from}>
  {item.name && <><div className="memberNameWrap"></div><p className="memberName">{item.name}</p></>}
  <div className={item.from+'Under'}></div>
  {item.text && <p className="comment_text1">{item.text}</p>}
  {item.img && <img src={item.img} height={item.height} style={{clear:"both", float:"left", width:"70vw"}} max-width='100%'/>}
  {item.poll && <div className="poll">
  <p className="PollQuestion" style={{display:"block",width:"60vw",marginBottom:"8px",marginTop:"0px"}}>Who's the winner?</p>
  {item.poll.map(function (item, index) {
    return(
    <div key={index} onClick={chooseOption} id={index} className="option">
  <b id={index} className={"perc"+index} style={{display:"inline",width:"23px",marginRight:"5px", float:"left", fontSize:"12px", paddingTop:"2px"}}>0%</b><p id={index} className={"optionText"+index} style={{display:"block",marginBottom:"3px", marginTop:"1.5vh"}}>{item}</p>
<div id={index} className="option" style={{display:"block",width:"80%",height:"5px", marginLeft:"28px"}}><div id={index} className={"percents"+index} style={{background:"#6822c7",width:"3%",height:"100%",borderRadius:"5px"}}></div></div>
</div>
)
})
}
  </div>}
  </div>
  </div>
);

})
}
</div>
</div>
  );
}

export default GroupChat;
